import { TextField } from "@material-ui/core";
import React, {
  useState,
  forwardRef,
  useEffect,
  useImperativeHandle,
} from "react";
import { Autocomplete } from "@material-ui/lab";
import { fetchConToken } from "../../../helpers/fetch";
import { BUSCADOR_CENTRAL } from "../../../utils/constants";

const AutoCompleteDiagnostico = forwardRef(
  ({ label, autoCompleteValue, onChangeHandler, disabled }, ref) => {
    
    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const [parametro, setParametro] = useState("");

    const onChangeOptionsHandler = (e) => {
      let typingTimer = null;
      if (e.target.value.length >= BUSCADOR_CENTRAL.CARACTERES_MINIMOS_AFILIACIONES) {
        clearTimeout(typingTimer);
        typingTimer = setTimeout(() => {
          setParametro(e.target.value);
        }, BUSCADOR_CENTRAL.MILISEG_SIN_CAMBIOS);
      } else {
        setOptions([]);
      }
    };

    useImperativeHandle(ref, () => ({
      resetValues: () => {
        setOptions([]);
      },
    }));

    useEffect(() => {
      let active = true;
      setLoading(true);
      (async () => {
        if (parametro.length > 0) {
          const response = await fetchConToken(
            `Diagnosticos/buscar?texto=${parametro}`
          );
          if (response.ok) {
            const options = await response.json();
            if (active && options.length > 0) {
              setOptions(options);
            }
          }
          setLoading(false);
        }
      })();
      return () => {
        active = false;
      };
    }, [parametro]);

    return (
      <Autocomplete
        value={autoCompleteValue}
        onChange={(event, newValue) => {
          onChangeHandler(newValue);
        }}
        options={options || []}
        loading={loading}
        loadingText="Buscando..."
        selectOnFocus
        clearOnBlur
        disabled={disabled}
        handleHomeEndKeys
        // getOptionLabel={(option) => `${option.idProblema}-${option.problema}`}
        getOptionLabel={(option) => `${option.problema}`}
        renderOption={(option) => (
          <div style={{ display: "flex", flexDirection: "column" }}>
            {/* <span>{`${option.idProblema}-${option.problema}`}</span> */}
            <span>{option.problema}</span>
          </div>
        )}
        freeSolo
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            onChange={onChangeOptionsHandler}
          />
        )}
      />
    );
  }
);

export default AutoCompleteDiagnostico;
